// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ESlb_","label":"styles_label__d15cQ"};